import styles from "./styles.module.css";
import React from "react";
import { MdCallSplit } from "react-icons/md";
import { WorkflowsDisbatch } from "../../../contexts/workflows";
export default function OpenWorklows() {
  const disbatch = React.useContext(WorkflowsDisbatch);
  return (
    <button
      className={styles.actionButton}
      onClick={() => disbatch({ type: "setOpen", value: true })}
    >
      Workflows
    </button>
  );
}
